


















import { computed } from '@vue/composition-api'
import { defineClassComponent } from '@/hooks'

export default defineClassComponent<{
  value: number
  showValue: boolean
}>(
  {
    props: ['value', 'showValue'],
  },
  ({ props }) =>
    class {
      val = computed(() => Math.round(props.value))
    },
)
